module.exports = __webpack_public_path__ + "static/img/complete_seoulone.89a8219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/complete_seoulone.png
// module id = 9YTA
// module chunks = 1